import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'least-expensive-badge',
  templateUrl: './least-expensive-badge.component.html',
  styles: [':host { display: contents; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeastExpensiveBadgeComponent {}
